import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const AutoPublishIntegrationModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "AutoPublishIntegrationModalContainer" */
      './AutoPublishIntegrationModalContainer'
    ),
  loading: LoadingModal,
});
